import React from 'react';

/**
 * Renders source from a given id, optionally parses the HTML with
 * the a function passed as the `parse` prop.
 *
 * Renders only once (assumes static content)
 */
export default class RenderIn extends React.Component {
  constructor(props) {
    const { sourceId, parse = (x) => x } = props;
    super(props);

    const element = document.getElementById(sourceId);
    this.html = element ? parse(element.innerHTML) : '';
  }
  shouldComponentUpdate() {
    return false;
  }
  render() {
    return (
      <div dangerouslySetInnerHTML={{ __html: this.html }} />
    );
  }
}
